import pageableFactory from '@/store/modules/mixins/pageable';

const pageable = pageableFactory();
const defaultState = () => ({
  ...pageable.state,
});

const templatesEnvelopesModule = {
  namespaced: true,
  state: defaultState(),
  mutations: {
    ...pageable.mutations,
    RESET_STATE(state) {
      Object.assign(state, defaultState());
    },
  },
  actions: {
    RESET_STATE({ commit }) {
      commit('RESET_STATE');
    },
    PAGINATE(...args) {
      return pageable.actions.paginatePartialApplication({
        url: `templates/${args[1].templateFingerprint}/envelopes`,
      }).apply(this, args);
    },
  },
  getters: {
    ...pageable.getters,
  },
};

export default templatesEnvelopesModule;
